<boels-vertical-aligner xmlns="http://www.w3.org/1999/html">
  <div class="boels-page-not-found__container">
    <img
      class="boels-page-not-found__image"
      src="assets/images/misc/boels-404.svg"
      tabindex="-1"
      alt="404 image"
    />
    <p class="boels-page-not-found__status">404</p>
    <ng-content></ng-content>
    <a
      boelsAnchorButton
      boelsGenericLink
      tabindex="0"
      [variant]="'primary-brand'"
      [url]="'/'"
    >
      {{ 'pageNotFound.goToHomePage' | transloco }}
    </a>
  </div>
</boels-vertical-aligner>
